import { LeaveRequestApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ICallback } from '../../../commonTypes/hook.types';

const useHttpDeleteLeaveRequest = () => {
    const leaveRequestApi: LeaveRequestApi = useContainer(LeaveRequestApi);

    const deleteLeaveRequest = (id: string, callback: ICallback) => {
        const { exec, abort } = leaveRequestApi.deleteLeaveRequest({
            params: { id },
            onSuccess: res => {
                callback.onSuccess && callback.onSuccess(res.body);
            },
            onError: error => console.log(error),
        });
        exec();
        return abort;
    };

    return { deleteLeaveRequest };
};

export default useHttpDeleteLeaveRequest;
